// LocalStorageService.js
const LocalStorageService = (function () {
  var _service;
  const authorizationData = 'ls.authorizationData';

  function _getService() {
    if (!_service) {
      _service = this;
      return _service
    }
    return _service
  }
  function _setToken(tokenObj) {
    localStorage.setItem('ls.authorizationData', JSON.stringify(tokenObj));
  }
  function _getAccessToken() {
    const authorizationData = localStorage.getItem("ls.authorizationData")

    try {
      if (authorizationData)
        return JSON.parse(authorizationData).access_token;
    } catch (err) {
      localStorage.removeItem('ls.authorizationData');
    }

  }
  function _getRefreshToken() {
    const authorizationData = localStorage.getItem("ls.authorizationData")

    if (authorizationData)
      return JSON.parse(authorizationData).refresh_token;
  }
  function _clearToken() {
    localStorage.removeItem('ls.authorizationData')
  }
  function _getRoles() {
    const authorizationData = localStorage.getItem("ls.authorizationData")

    if (authorizationData)
      return JSON.parse(authorizationData).roles
  }
  function _getUserName() {
    try {
      const authorizationData = localStorage.getItem("ls.authorizationData")

      if (authorizationData)
        return JSON.parse(authorizationData).userName
    } catch (err) {
      localStorage.removeItem('ls.authorizationData');
    }
  }
  return {
    getService: _getService,
    setToken: _setToken,
    getAccessToken: _getAccessToken,
    getRefreshToken: _getRefreshToken,
    clearToken: _clearToken,
    getRoles: _getRoles,
    getUserName: _getUserName,
  }

})();

export default LocalStorageService;